import { render, staticRenderFns } from "./TheSignMessageLayout.vue?vue&type=template&id=4b18a83e"
import script from "./TheSignMessageLayout.vue?vue&type=script&lang=js"
export * from "./TheSignMessageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports